<template lang="pug">
    .tab-content
        .md-layout.md-gutter(v-if="$props.who == 1 && deal.sender")
            //.md-layout-item.md-alignment-top-left.md-size-100 Для редактирования данных перейдите на вкладку "Отправитель"
            .md-layout-item.md-alignment-top-left.md-size-100(v-if="deal.sender.name")
                z-input(name="sender_payer_name"  id="sender_payer_name"  label="Наименование/Имя" readonly v-model="deal.sender.name")
            .md-layout-item.md-alignment-top-left.md-size-100(v-if="deal.sender.phone")
                z-input(name="sender_payer_phone" id="sender_payer_phone" label="Номер телефона"   readonly v-model="deal.sender.phone" inline)
            .md-layout-item.md-alignment-top-left.md-size-100(v-if="deal.sender.email")
                z-input(name="sender_payer_email" id="sender_payer_email" label="Email"            readonly v-model="deal.sender.email" inline)
            .md-layout-item.md-alignment-top-left.md-size-100(v-if="deal.sender.inn")
                z-input(name="sender_payer_inn"   id="sender_payer_inn"   label="ИНН"              readonly v-model="deal.sender.inn" inline)
            .md-layout-item.md-alignment-top-left.md-size-100(v-if="deal.sender.kpp")
                z-input(name="sender_payer_kpp"   id="sender_payer_kpp"   label="КПП"              readonly v-model="deal.sender.kpp" inline)
            .md-layout-item.md-alignment-top-left.md-size-100(v-if="deal.sender.passport_number")
                z-input(name="sender_payer_passport_number" id="sender_payer_passport_number" label="Номер паспорта" readonly v-model="deal.sender.passport_number" inline)

        .md-layout.md-gutter(v-if="$props.who == 2 && deal.recipient")
            //.md-layout-item.md-alignment-top-left.md-size-100 Для редактирования данных перейдите на вкладку "Получатель"
            .md-layout-item.md-alignment-top-left.md-size-100(v-if="deal.recipient.name")
                z-input(name="recipient_payer_name"  id="recipient_payer_name"  label="Наименование/Имя" readonly v-model="deal.recipient.name")
            .md-layout-item.md-alignment-top-left.md-size-100(v-if="deal.recipient.phone")
                z-input(name="recipient_payer_phone" id="recipient_payer_phone" label="Номер телефона"   readonly v-model="deal.recipient.phone" inline)
            .md-layout-item.md-alignment-top-left.md-size-100(v-if="deal.recipient.email")
                z-input(name="recipient_payer_email" id="recipient_payer_email" label="Email"            readonly v-model="deal.recipient.email" inline)
            .md-layout-item.md-alignment-top-left.md-size-100(v-if="deal.recipient.inn")
                z-input(name="recipient_payer_inn"   id="recipient_payer_inn"   label="ИНН"              readonly v-model="deal.recipient.inn" inline)
            .md-layout-item.md-alignment-top-left.md-size-100(v-if="deal.recipient.kpp")
                z-input(name="recipient_payer_kpp"   id="recipient_payer_kpp"   label="КПП"              readonly v-model="deal.recipient.kpp" inline)
            .md-layout-item.md-alignment-top-left.md-size-100(v-if="deal.recipient.passport_number")
                z-input(name="recipient_payer_passport_number" id="recipient_payer_passport_number" label="Номер паспорта" readonly v-model="deal.recipient.passport_number" inline)
        div(v-if="$props.who == 3")
            z-select(
                label="Тип плательщика"
                v-model="customer.type"
                :required="true"
                name="payer_type"
                id="payer_type"
                v-validate="'required'"
                v-bind:error="errors.first('payer_type')"
                data-vv-name="payer_type"
                v-bind:data-vv-as="' '"
                v-bind:disabled="$props.block"
                inline
                v-on:change="changeType"
                v-bind:dirty.sync="dirtyObj.type"
            )
                option(v-bind:value="'1'") Юридическое лицо
                option(v-bind:value="'3'") Индивидуальный предприниматель
                option(v-bind:value="'2'") Физическое лицо

            .md-layout.md-gutter(v-if="customer && customer.type" v-show="([1,3].indexOf(parseInt(customer.type))+1)")
                .md-layout-item.md-alignment-top-left.md-size-100
                    ZInputAutocomplete(
                        v-bind:update-on-input="true"
                        label="ИНН"
                        v-bind:items="customersUl"
                        v-model="customer.inn"
                        v-bind:callback="searchCustomerByInn"
                        v-on:select="selectCustomer"
                        v-on:clear="clearCustomer"
                        v-bind:length-on-search="3"
                        display-property="inn"
                        display-property-list="ul_inn_label"
                        property="inn"
                        v-bind:default="customer.inn"
                        :required="!!([1,3].indexOf(parseInt(customer.type))+1)"
                        name="payer_inn"
                        id="payer_inn"
                        v-validate="{'required': !!([1,3].indexOf(parseInt(customer.type))+1)}"
                        v-bind:error="errors.first('payer_inn')"
                        data-vv-name="payer_inn"
                        v-bind:data-vv-as="' '"
                        ref="inn"
                        v-bind:disabled="$props.block"
                        inline
                        v-bind:dirty.sync="dirtyObj.inn"
                    )
                .md-layout-item.md-alignment-top-left.md-size-100
                    z-input(
                        v-show="hasInn"
                        label="Наименование"
                        v-model="customer.name"
                        :required="!!([1,3].indexOf(parseInt(customer.type))+1)"
                        name="payer_name"
                        id="payer_name"
                        v-bind:disabled="!customer.allow_edit || $props.block"
                        v-validate="{'required': !!([1,3].indexOf(parseInt(customer.type))+1)}"
                        v-bind:error="errors.first('payer_name')"
                        data-vv-name="payer_name"
                        v-bind:data-vv-as="' '"
                        inline
                        v-bind:dirty.sync="dirtyObj.name"
                    )
                .md-layout-item.md-alignment-top-left.md-size-100
                    z-input(
                        v-show="hasInn"
                        v-if="parseInt(customer.type) != 3"
                        name="payer_kpp" 
                        id="payer_kpp" 
                        label="КПП" 
                        v-model="customer.kpp" 
                        v-bind:error="errors.first('payer_kpp')"
                        v-bind:minlength="9"
                        v-bind:maxlength="9"
                        type="number"
                        :required="parseInt(customer.type) == 1 ? true : false"
                        v-validate="parseInt(customer.type) == 1 ? 'required|max:9|min:9' : ''"
                        data-vv-name="payer_kpp"
                        v-bind:data-vv-as="' '"
                        v-bind:disabled="(!customer.allow_edit || $props.block) && !customer.allow_edit_kpp"
                        inline
                        v-bind:dirty.sync="dirtyObj.kpp"
                    )
            .md-layout.md-gutter(v-if="customer && customer.type" v-show="parseInt(customer.type) === 2")
                .md-layout-item.md-alignment-top-left.md-size-100
                    ZInputAutocomplete(
                        v-bind:update-on-input="true"
                        label="Номер паспорта"
                        v-bind:items="customersFl"
                        v-model="customer.passport_number"
                        v-bind:callback="searchCustomerByPassport"
                        v-on:select="selectCustomer"
                        v-on:clear="clearCustomer"
                        v-bind:length-on-search="4"
                        display-property="passport_number"
                        display-property-list="fl_passport_label"
                        property="passport_number"
                        name="payer_passport_number"
                        id="payer_passport_number"
                        v-bind:default="customer.passport_number"
                        mask="99 99 999999"
                        :required="(parseInt(customer.type) === 2 ? true : false)"
                        v-validate="(parseInt(customer.type) === 2 ? 'required' : '')"
                        validate="passport"
                        v-bind:error="errors.first('payer_passport_number')"
                        data-vv-name="payer_passport_number"
                        v-bind:data-vv-as="' '"
                        ref="passport"
                        v-bind:disabled="$props.block"
                        inline
                        v-bind:dirty.sync="dirtyObj.passport"
                    )
                .md-layout-item.md-alignment-top-left.md-size-100
                    z-input(
                        v-show="hasPassport"
                        label="ФИО"
                        v-model="customer.name"
                        name="payer_fio"
                        id="payer_fio"
                        :required="true"
                        v-bind:disabled="!customer.allow_edit || $props.block"
                        v-validate="'required'"
                        v-bind:error="errors.first('payer_fio')"
                        data-vv-name="payer_fio"
                        v-bind:data-vv-as="' '"
                        inline
                        v-bind:dirty.sync="dirtyObj.name"
                    )

            z-input(
                label="Адрес для документов"
                id="payer_docaddress"
                name="payer_docaddress"
                v-model="customer.doc_address"
                v-bind:disabled="$props.block"
                v-validate="'min:1|max:1000'"
                v-bind:data-vv-as="' '"
                v-bind:error="errors.first('doc_address')"
                v-bind:dirty.sync="dirtyObj.doc_address"
                inline
            )

            multy-autocomplete(
                v-show="hasInn || hasPassport"
                ref="contact"
                placeholder="Контактное лицо"
                label="Контактное лицо"
                display-property="label"
                property="name"
                return="id"
                v-model="customer.attached_contacts"
                v-bind:showOnFocus="true"
                v-bind:items="contacts"
                v-bind:show-search-input="false"
                v-on:select="selectContact"
                :required="true"
                v-bind:can-add="true"
                id="payer_contact"
                name="payer_contact"
                v-validate="'required'"
                v-bind:error="errors.first('payer_contact')"
                data-vv-name="payer_contact"
                v-bind:data-vv-as="' '"
                v-bind:tolltip-fields="{phone: 'Тел', email: 'E-mail'}"
                inline
                v-bind:dirty.sync="dirtyObj.contacts"
            )
                z-input(
                    name="payer_contact_name" id="payer_contact_name" label="Имя" required v-model="newContact.name" 
                    v-validate="'required|alpha_spaces'" v-bind:error="errors.first('contact.payer_contact_name')"
                    data-vv-name="payer_contact_name"
                    v-bind:data-vv-as="' '"
                    data-vv-scope="contact"
                )    
                z-input(
                    name="payer_contact_phone" id="payer_contact_phone" label="Телефон" v-model="newContact.phone" mask="+7 (999) 999-99-99"
                    v-validate="{required: true, regex: /^\\+7 \\(\\d{3}\\) \\d{3}-\\d{2}-\\d{2}$/ }" v-bind:error="errors.first('contact.payer_contact_phone')"
                    data-vv-name="payer_contact_phone"
                    v-bind:data-vv-as="' '"
                    data-vv-scope="contact"
                )
                z-input(
                    name="payer_contact_email" id="payer_contact_email" label="E-mail" v-model="newContact.email" 
                    v-validate="'email'" v-bind:error="errors.first('contact.payer_contact_email')"
                    data-vv-name="payer_contact_email"
                    v-bind:data-vv-as="' '"
                    data-vv-scope="contact"
                )
                md-button.md-primary.md-dense(v-on:click="saveContact") Сохранить
</template>
<script>
    import ZInputAutocomplete from '@/components/ZInputAutocomplete'
    import Properties from '@/components/Properties'
    import WacomSignature from '@/components/WacomSignature';
    import MultyAutocomplete from '@/components/MultyAutocomplete';
    import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
    export default {
        name: 'payer',
        props: {
            value: {
                type: Object,
                default: () => {
                    return {
                        id: null,
                        hid: null,
                        created_at: null,
                        updated_at: null,
                        name: null,
                        type: 1,
                        inn: null,
                        kpp: null,
                        passport_number: null,
                        checking_account: null,
                        correspondent_account: null,
                        bic: null,
                        bank: null,
                        sort: 100,
                        phone: null,
                        email: null,
                        nds: 0,
                        attached_contacts: [],
                        addresses: [],
                        contacts: []
                    }
                }
            },
            customersUl: {
                type: Array,
                default: []
            },
            customersFl: {
                type: Array,
                default: []
            },
            deal: {
                type: Object,
                default: () => {
                    return {id: null}
                }
            },
            who: {
                type: Number,
                default: 1
            },
            block: {
                type: Boolean,
                default: false
            },
            searchByInnCallback: {
                type: Function,
                default: () => {}
            },
            searchCustomerByPassportCallback: {
                type: Function,
                default: () => {}
            },
            breakCustomerCallback: {
                type: Function,
                default: () => {}
            },
            dirty: {
                type: Boolean,
                default: false
            }
        },
        components: {
            Properties,
            ZInputAutocomplete,
            WacomSignature,
            MultyAutocomplete,
            ZInput, ZSelect
        },
        data() {
            return {
                parent: null,
                contacts: [],
                newContact: {
                    id: null,
                    name: null,
                    description: null,
                    phone: null,
                    email: null,
                    customer_id: null,
                    sort: null
                },
                newContactDefault: {
                    id: null,
                    name: null,
                    description: null,
                    phone: null,
                    email: null,
                    customer_id: null,
                    sort: null
                },
                customer: {
                    id: null,
                    hid: null,
                    created_at: null,
                    updated_at: null,
                    name: null,
                    type: 1,
                    inn: null,
                    kpp: null,
                    passport_number: null,
                    checking_account: null,
                    correspondent_account: null,
                    bic: null,
                    bank: null,
                    sort: 100,
                    phone: null,
                    email: null,
                    nds: 0,
                    attached_contacts: [],
                    addresses: [],
                    contacts: []
                },
                defaultCustomer: {
                    id: null,
                    hid: null,
                    created_at: null,
                    updated_at: null,
                    name: null,
                    type: 1,
                    inn: null,
                    kpp: null,
                    passport_number: null,
                    checking_account: null,
                    correspondent_account: null,
                    bic: null,
                    bank: null,
                    sort: 100,
                    phone: null,
                    email: null,
                    nds: 0,
                    attached_contacts: [],
                    addresses: [],
                    contacts: []
                },
                dirtyObj: {
                    type: false,
                    inn: false,
                    name: false,
                    kpp: false,
                    passport: false,
                    contacts: false,
                    doc_address: false
                }
            }
        },
        computed: {
            hasInn() {
                return this.customer.inn && (this.customer.inn.length >= 10);
            },
            hasPassport() {
                return this.customer.passport_number && (this.customer.passport_number.replace(/\D/g, "").length >= 10);
            },
            isDirty() {
                return !!Object.values(this.dirtyObj).find(item => item);
            }
        },
        watch: {
            '$props.value': {
                deep: true,
                handler(value) {
                    this.init(value);
                }
            },
            'customer': {
                deep: true,
                handler(customer, old) {
                    this.$emit('change', customer);
                    this.$emit('input', customer);
                    this.prepareContacts();
                }
            },
            '$props.who'(who, old) {
                // Выходим если старое значение null т.к. это происходит только в момент загрузки, иначе при who = 3 сбрасывается значение
                if (!old || parseInt(who) === parseInt(old)) return;
                let customer = {}
                if (parseInt(who) == 1)      customer = Object.assign({}, this.deal.sender);
                else if (parseInt(who) == 2) customer = Object.assign({}, this.deal.recipient);
                else if (!this.customer.id || this.customer.id == 'new') customer = Object.assign({}, this.defaultCustomer);
                
                if (!customer.pivot) customer.pivot = {};
                if (!customer.pivot.payment_method_id) customer.pivot.payment_method_id = parseInt(this.deal.payment_method_id);
                this.customer = Object.assign({}, customer);
            },
            'customer.contacts': {
                deep: true,
                handler(contacts) {
                    this.$emit('change-contacts', 'payer', contacts);
                }
            },
            'isDirty'(val) {
                if (val) this.emitDirty();
            }
        },
        methods: {
            emitDirty() {
                this.$emit('update:dirty', this.isDirty);
            },
            init(customer) {
                if (customer && JSON.stringify(customer) != JSON.stringify(this.customer)) {
                    this.validateClear();
                    if (customer.attached_contacts && customer.attached_contacts.length) customer.attached_contacts = Object.assign([], customer.attached_contacts.map(contact => {
                        contact.label = contact.name + (contact.phone ? (', ' + contact.phone) : '') + '';
                        return contact;
                    }));
                    this.customer = Object.assign({}, customer);
                    this.prepareContacts();
                }
            },
            prepareContacts() {
                if (!this.customer || !this.customer.contacts || !this.customer.contacts.length) this.contacts = [];
                else this.contacts = Object.assign([], this.customer.contacts.map(contact => {
                    contact.label = contact.name + (contact.phone ? (', ' + contact.phone) : '') + '';
                    return contact;
                }));
            },
            validateClear() {
                this.errors.clear();
                this.$validator.errors.clear();
                this.$validator.reset();
                if (this.$refs.inn) this.$refs.inn.validateClear();
                if (this.$refs.passport) this.$refs.passport.validateClear();
            },
            searchCustomerByInn(inn) {
                return this.searchByInnCallback(inn, 'payer', this.$refs.inn);
            },
            selectCustomer(value, customer) {
                if (!customer.pivot) customer.pivot = {};
                if (!customer.pivot.payment_method_id) customer.pivot.payment_method_id = parseInt(this.$props.deal.payment_method_id);
                this.customer = Object.assign({}, customer);
            },
            searchCustomerByPassport(passport) {
                return this.searchCustomerByPassportCallback(passport, 'payer', this.$refs.passport);
            },
            changeType() {
                this.customer.id = null;
                this.customer.inn = null;
                this.customer.name = null;
                this.customer.passport_number = null;
            },
            clearCustomer() {
                return this.breakCustomerCallback('payer');
            },
            selectContact(item) {},
            saveContact() {
                this.$validator.validateAll('contact').then(valid => {
                    if (!valid) return;
                    if (this.$refs.contact) {
                        this.newContact.sort = 100;
                        this.newContact.customer_id = this.customer.id;

                        //Если контрагент уже существует, сохраняем контакт на БЕ
                        if (this.customer.id && this.customer.id != 'new') this.$store.dispatch('customers/addCustomerContacts', {contacts: this.newContact}).then(contact => {
                                if (!contact || !contact.id) return;
                                this.newContact = Object.assign({}, contact);
                                this.customer.contacts.push(Object.assign({}, this.newContact));
                                setTimeout(() => { //Без setTimeout инпут this.$refs.contact не успевает обработать новый список КЛ и они начинают дублироваться, nextTick не помогает
                                    this.$refs.contact.selectItem(this.newContact, true);    
                                    this.$refs.contact.hideAddForm();
                                    this.newContact = Object.assign({}, this.newContactDefault);
                                }, 0);
                            });
                        else { //Иначе просто добавляем его в список (сохранение произойдёт на БЕ в момент сохранения всей заявки)
                            this.customer.contacts.push(Object.assign({}, this.newContact));
                            setTimeout(() => { //Без setTimeout инпут this.$refs.contact не успевает обработать новый список КЛ и они начинают дублироваться
                                this.$refs.contact.selectItem(this.newContact, true);    
                                this.$refs.contact.hideAddForm();
                                this.newContact = Object.assign({}, this.newContactDefault);
                            }, 0);
                        }
                    }
                });
            },
            async validate() {
                let valid = await this.$validator.validateAll();
                //Проверка только для юрика
                let isValidSelection = await new Promise((resolve, reject) => {
                    if ((!this.customer || (!this.customer.id && !this.customer.hid)) && parseInt(this.customer.type) != 2) {
                        this.$store.commit('showSnackbar', [
                            ('Контрагент: Плательщик<br>' +
                            (this.customer.inn  ? ('ИНН: ' + this.customer.inn + '<br>') : '') +
                            (this.customer.name ? ('Название: ' + this.customer.name + '<br>') : '') +
                            'Не действительный.<br><br>Проверьте контрагента по <a href="' + this.$root.config.egrulUrl + '" target="_blank" style="color: #fff; text-decoration: underline;">ссылке</a>'),
                            10000, 'error'
                        ]);
                        this.$nextTick(() => resolve(false));
                    } else resolve(true);
                });
                if (!isValidSelection) return false;
                return valid;
            }
        },
        created() {
            this.$nextTick(() => this.init(this.$props.value));
        },
    }
</script>



// WEBPACK FOOTER //
// Payer.vue?88382adc